import {Injectable} from '@angular/core';
import {HttpService} from './http.service';
/**
 * @class TimeService
 * @description This is a service which provide current time
 */
@Injectable({
    providedIn: 'root'
})

export class TimeService {
    timestamp = Date.now();

    constructor() {
    }
}
